import { useRef } from 'react';

import type { StoreDrawerAlign, StoreDrawerOpenState } from '@libs/common-next';

type CartStoreDrawerOpen = { open: boolean };

export const useDrawerSide = (
    storeDrawerOpen: StoreDrawerOpenState | null,
    cartStoreDrawerOpen: CartStoreDrawerOpen
): { drawerSide: StoreDrawerAlign; isDrawerActive: boolean } => {
    const lastDrawerSideRef = useRef<StoreDrawerAlign>('right');
    const isDrawerActive = Boolean(storeDrawerOpen) || cartStoreDrawerOpen.open;
    const resolvedAlign = storeDrawerOpen?.align ?? (cartStoreDrawerOpen.open ? 'right' : undefined);

    const drawerSide = resolvedAlign ?? (isDrawerActive ? 'right' : lastDrawerSideRef.current);

    if (isDrawerActive) {
        lastDrawerSideRef.current = drawerSide;
    }

    return { drawerSide, isDrawerActive };
};
